import { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

function Navigation() {
  const { isLoggedIn, isLoading, user, signOut } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  async function handleSignOut() {
    setMenuOpen(false);
    await signOut();
    navigate('/');
  }

  return (
    <nav className='nav'>
      <div className='nav-inner'>
        <NavLink to='/' className='nav-brand' aria-label='RosterRx'>
          RosterRx
          <span className='nav-tagline' aria-hidden='true'>Ask the Doctor to fix your roster</span>
        </NavLink>
        <div className='filter-group'>
          <NavLink
            to='/'
            end
            className={({ isActive }) => `filter-pill ${isActive ? 'active' : ''}`}
          >
            Football
          </NavLink>
          <NavLink
            to='/baseball'
            className={({ isActive }) => `filter-pill ${isActive ? 'active' : ''}`}
          >
            Baseball
          </NavLink>
        </div>
        <button className='filter-pill nav-theme-toggle' onClick={toggleTheme}>
          {theme === 'cool' ? '☀ Light Mode' : '🖥 Cool Mode'}
        </button>
        <div className='nav-auth'>
          {!isLoading && !isLoggedIn && (
            <NavLink to='/login' className='filter-pill'>
              Login
            </NavLink>
          )}
          {!isLoading && isLoggedIn && (
            <div className='nav-profile-menu' ref={menuRef}>
              <button
                className='filter-pill nav-profile-btn'
                onClick={() => setMenuOpen(o => !o)}
              >
                {user?.email?.split('@')[0] ?? 'Account'}
              </button>
              {menuOpen && (
                <div className='nav-dropdown'>
                  <div className='nav-dropdown-email'>{user?.email}</div>
                  <NavLink
                    to='/profile'
                    className='nav-dropdown-item'
                    onClick={() => setMenuOpen(false)}
                  >
                    My Profile
                  </NavLink>
                  <NavLink
                    to='/opponents'
                    className='nav-dropdown-item'
                    onClick={() => setMenuOpen(false)}
                  >
                    Opposing Managers
                  </NavLink>
                  <button className='nav-dropdown-item nav-dropdown-signout' onClick={handleSignOut}>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className='nav-subnav'>
        <div className='nav-subnav-inner'>
          <NavLink to='/' end className={({ isActive }) => `nav-subnav-link${isActive ? ' active' : ''}`}>
            Rankings
          </NavLink>
          <NavLink to='/draft' className={({ isActive }) => `nav-subnav-link${isActive ? ' active' : ''}`}>
            Drafts
          </NavLink>
          <NavLink to='/league' className={({ isActive }) => `nav-subnav-link${isActive ? ' active' : ''}`}>
            League
          </NavLink>
          <NavLink to='/about' className={({ isActive }) => `nav-subnav-link${isActive ? ' active' : ''}`}>
            About
          </NavLink>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
